export const PPH_23_DATA = {
  // 15% Category: Interest, Royalties, Prizes/Awards
  "24-102-01": { baseRate: 0.15 },
  "24-103-01": { baseRate: 0.15 },
  "24-100-01": { baseRate: 0.15 },

  // 2% Category: Rent and Services
  "24-100-02": { baseRate: 0.02 },
  "24-104-01": { baseRate: 0.02 },
  "24-104-02": { baseRate: 0.02 },
  "24-104-03": { baseRate: 0.02 },
  "24-104-04": { baseRate: 0.02 },
  "24-104-05": { baseRate: 0.02 },
  "24-104-06": { baseRate: 0.02 },
  "24-104-07": { baseRate: 0.02 },
  "24-104-08": { baseRate: 0.02 },
  "24-104-09": { baseRate: 0.02 },
  "24-104-10": { baseRate: 0.02 },
  "24-104-11": { baseRate: 0.02 },
  "24-104-12": { baseRate: 0.02 },
  "24-104-13": { baseRate: 0.02 },
  "24-104-14": { baseRate: 0.02 },
  "24-104-15": { baseRate: 0.02 },
  "24-104-16": { baseRate: 0.02 },
  "24-104-17": { baseRate: 0.02 },
  "24-104-18": { baseRate: 0.02 },
  "24-104-19": { baseRate: 0.02 },
  "24-104-20": { baseRate: 0.02 },
  "24-104-21": { baseRate: 0.02 },
  "24-104-22": { baseRate: 0.02 },
  "24-104-23": { baseRate: 0.02 },
  "24-104-24": { baseRate: 0.02 },
  "24-104-25": { baseRate: 0.02 },
  "24-104-26": { baseRate: 0.02 },
  "24-104-27": { baseRate: 0.02 },
  "24-104-28": { baseRate: 0.02 },
  "24-104-29": { baseRate: 0.02 },
  "24-104-30": { baseRate: 0.02 },
  "24-104-31": { baseRate: 0.02 },
  "24-104-32": { baseRate: 0.02 },
  "24-104-33": { baseRate: 0.02 },
  "24-104-34": { baseRate: 0.02 },
  "24-104-35": { baseRate: 0.02 },
  "24-104-36": { baseRate: 0.02 },
  "24-104-37": { baseRate: 0.02 },
  "24-104-38": { baseRate: 0.02 },
  "24-104-39": { baseRate: 0.02 },
  "24-104-40": { baseRate: 0.02 },
  "24-104-41": { baseRate: 0.02 },
  "24-104-42": { baseRate: 0.02 },
  "24-104-43": { baseRate: 0.02 },
  "24-104-44": { baseRate: 0.02 },
  "24-104-45": { baseRate: 0.02 },
  "24-104-46": { baseRate: 0.02 },
  "24-104-47": { baseRate: 0.02 },
  "24-104-48": { baseRate: 0.02 },
  "24-104-49": { baseRate: 0.02 },
  "24-104-50": { baseRate: 0.02 },
  "24-104-51": { baseRate: 0.02 },
  "24-104-52": { baseRate: 0.02 },
  "24-104-53": { baseRate: 0.02 },
  "24-104-54": { baseRate: 0.02 },
  "24-104-55": { baseRate: 0.02 },
  "24-104-56": { baseRate: 0.02 },
  "24-104-57": { baseRate: 0.02 },
  "24-104-58": { baseRate: 0.02 },
  "24-104-59": { baseRate: 0.02 },
  "24-104-60": { baseRate: 0.02 },
  "24-104-61": { baseRate: 0.02 },
  "24-104-62": { baseRate: 0.02 },
  "24-104-63": { baseRate: 0.02 },
  "24-104-64": { baseRate: 0.02 },
  "24-104-65": { baseRate: 0.02 },
  "24-104-66": { baseRate: 0.02 },
  "24-104-67": { baseRate: 0.02 },
  "24-104-68": { baseRate: 0.02 },
  "24-104-69": { baseRate: 0.02 },
};

export const PPH_23_OBJECT_CODES = Object.keys(PPH_23_DATA);
